import Vue from 'vue';
import {
  Button,
  Drawer,
  Radio,
  RadioGroup,
  RadioButton,
  Link,
  Row,
  PageHeader,
  Input,
  Tooltip,
  ButtonGroup,
  Slider,
  Divider,
  Switch,
  Select,
  Option,
  Card,
  Dialog,
  Steps,
  Step,
  Result,
  Popover,
  Popconfirm,
  Alert,
  Carousel,
  CarouselItem,
  Message,
  Loading,
  MessageBox,
  Notification
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Alert)
Vue.use(Result)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Card)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Drawer)
Vue.use(Radio)
Vue.use(Link)
Vue.use(Row)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(PageHeader)
Vue.use(Input)
Vue.use(Tooltip)
Vue.use(ButtonGroup)
Vue.use(Slider)
Vue.use(Divider)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(Popover)
Vue.use(Popconfirm)
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Loading.directive);


Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

